import { useState } from "react";
import { useFormikContext } from "formik";
import { Collapse, IconButton, Paper, Stack, styled, Switch, TextField, Tooltip, Typography } from "@mui/material";
import get from "lodash/get";
import Schedule from "@/components/Schedule";
import { ArrowDown01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { OrganizationSettings } from "@/types";
import { Schedule as ISchedule } from "@/types/branch";

interface Props {
  title: string;
  description?: string;
  field: string;
  disabled?: boolean;
  value?: ISchedule;
  onChange?: (value: ISchedule) => void;
}

const ExpandMore = styled(IconButton)(({ theme, expand }: { theme: any; expand: boolean }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const FlowScheduleSetting = ({ title, description, field, disabled, value, onChange }: Props) => {
  const { values, setFieldValue } = useFormikContext<OrganizationSettings>();
  const [isExpanded, setIsExpanded] = useState(false);

  const handleExpandClick = () => {
    setIsExpanded(!isExpanded);
  };

  const baseServicePath = field.substring(0, field.lastIndexOf("."));

  const scheduleFieldPath = `${baseServicePath}.schedule`;

  const isEnabled = get(values, field, false);

  const scheduleValue = value ?? get(values, scheduleFieldPath);

  const scheduleChangeHandler =
    onChange ??
    ((val: ISchedule) => {
      setFieldValue(scheduleFieldPath, val);
    });

  return (
    <Stack spacing={2}>
      <Paper sx={{ padding: 2 }}>
        <Stack spacing={{ xs: 3, md: 2 }} direction={{ md: "row" }} alignItems={"center"} justifyContent={"space-between"}>
          <Stack>
            <Typography variant="h4">{title}</Typography>
            {description ? (
              <Typography variant="body1" color="text.secondary">
                {description}
              </Typography>
            ) : null}
          </Stack>
          <Stack spacing={2} direction={"row"} alignItems={"center"} justifyContent={"flex-end"}>
            {isEnabled ? (
              <ExpandMore expand={isExpanded} onClick={handleExpandClick} aria-expanded={isExpanded} aria-label="mostrar horario">
                <Tooltip title={isExpanded ? "Ocultar horario" : "Mostrar horario"}>
                  <HugeiconsIcon icon={ArrowDown01Icon} />
                </Tooltip>
              </ExpandMore>
            ) : null}
            <Switch
              disabled={disabled}
              checked={isEnabled}
              onChange={(e: { target: { checked: boolean } }) => {
                setFieldValue(field, e.target.checked);
              }}
            />
          </Stack>
        </Stack>

        {isEnabled ? (
          <Collapse in={isExpanded} timeout="auto" unmountOnExit>
            <Stack spacing={2} sx={{ marginTop: 2 }}>
              {baseServicePath.includes("delivery") ? (
                <TextField
                  size="small"
                  type="number"
                  fullWidth
                  label="Tarifa Fija"
                  value={get(values, `${baseServicePath}.fee.value`, 0)}
                  onChange={(e) => {
                    setFieldValue(`${baseServicePath}.fee.value`, e.target.value);
                  }}
                />
              ) : null}

              <Schedule title="Programación" schedule={scheduleValue as ISchedule} onChange={scheduleChangeHandler} />
            </Stack>
          </Collapse>
        ) : null}
      </Paper>
    </Stack>
  );
};
export default FlowScheduleSetting;
